import { render } from "./EditRol.vue?vue&type=template&id=60838916"
import script from "./EditRol.vue?vue&type=script&lang=js"
export * from "./EditRol.vue?vue&type=script&lang=js"

import "./EditRol.vue?vue&type=style&index=0&id=60838916&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__